import React, { useState, useEffect } from 'react';
import { useModalClose } from '../hooks/useModalClose';
import '../styles/ContactModal.css';

const DemoModal = ({ show, onClose }) => {
  // Smooth close handler with animation - match other modals (200ms)
  const { isClosing, handleClose } = useModalClose(onClose, 200);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // Add fade-in delay to make modal appearance less abrupt
  useEffect(() => {
    if (show) {
      setIsInitialLoad(true);
      // Small delay before showing content to prevent abrupt appearance
      const timer = setTimeout(() => {
        setIsInitialLoad(false);
      }, 100);
      return () => clearTimeout(timer);
    } else {
      setIsInitialLoad(true);
    }
  }, [show]);

  if (!show) return null;

  return (
    <div className={`modal-overlay ${isClosing ? 'closing' : ''}`} onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {/* Close button */}
        <button 
          className="modal-close-button" 
          onClick={handleClose} 
          aria-label="Close demo modal"
          style={{ opacity: isInitialLoad ? 0 : 1, transition: 'opacity 0.2s ease' }}
        >
          ×
        </button>

        {/* Balloon logo */}
        <img
          src="/images/rmxballoonz.png"
          alt="RE/MAX Balloon"
          className="modal-balloon-logo"
          style={{ opacity: isInitialLoad ? 0 : 1, transition: 'opacity 0.2s ease' }}
        />

        {/* Title */}
        <h2 style={{ 
          color: '#0C2749',
          opacity: isInitialLoad ? 0 : 1,
          transition: 'opacity 0.2s ease'
        }}>
          Demo Mode
        </h2>

        {/* Description */}
        <p style={{
          fontSize: '1rem',
          lineHeight: '1.6',
          marginBottom: '20px',
          color: '#333',
          opacity: isInitialLoad ? 0 : 1,
          transition: 'opacity 0.2s ease'
        }}>
          You're viewing a static snapshot of open house data. 
          This is for demonstration purposes only.
        </p>

        {/* Button */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '10px',
          opacity: isInitialLoad ? 0 : 1,
          transition: 'opacity 0.2s ease'
        }}>
          <button
            onClick={handleClose}
            style={{
              backgroundColor: '#0C2749',
              color: 'white',
              border: 'none',
              padding: '12px 32px',
              borderRadius: '6px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#0043ff';
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#0C2749';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default DemoModal;
